import axios from '@axios'

const route = 'sales/order_service'
let updateOrderServiceQueue = Promise.resolve()

export default {
  namespaced: true,
  state: {
    startNewOrderService: false, // status para iniciar criacao de uma nova ordem de serviço (comanda)
    orderServices: [],
    checkout: [],
    customer: {},
    orderServiceSelected: {},
    typePdv: 'venda', // venda | serviço | atendimento | produto
  },
  getters: {

    /**
     * retorna cliente selecionado
     */
    getCustomer(state) {
      return state.customer
    },

    /**
     * retona ordem Servico selecionada
     */
    getOrderServiceSelected(state) {
      return state.orderServiceSelected
    },

    /**
     * Retorna as ordens de serviço (comandas)
     */
    getOrderServices(state) {
      return state.orderServices
    },

    /**
     * Retorna o status de iniciar uma nova ordem de serviço (comanda)
     */
    getStartNewOrderService(state) {
      return state.startNewOrderService
    },

    /**
     * Retorna os itens do checkout
     */
    getCheckout(state) {
      return state.checkout
    },

    /**
     * retorna se a comandas deve ser exibida por status
     */
    getTypePdv(state) {
      return state.typePdv
    },

  },
  mutations: {
    /**
     * Define o cliente da ordem de serviço (comanda)
     */
    setCustomer(state, customer) {
      state.customer = customer
    },

    /**
     * Define a ordem de serviço (comanda) selecionada
     */
    setOrderServiceSelected(state, orderService) {
      state.orderServiceSelected = orderService
    },

    /**
     * Define o loading de uma ordem de serviço (comanda)
     */
    setLoading(state, { orderService, btn, loading }) {
      const os = state.orderServices.find(os => os.id === orderService.id)
      os[btn] = loading
    },

    /**
     * update status de uma ordem de serviço (comanda)
     */
    updateStatusOrderService(state, { id, status }) {
      const orderService = state.orderServices.find(os => os.id === id)
      orderService.status = status
    },

    /**
     * Define as ordens de serviço (comandas)
     */

    setOrderServices(state, orderServices) {
      state.orderServices = orderServices
    },

    /**
     * da start para criar uma nova ordem de serviço (comanda)
     */
    setStartNewOrderService(state, status) {
      state.startNewOrderService = status
    },

    /**
     * Criar uma nova ordem de serviço (comanda)
     */
    addOrderService(state, orderService) {
      state.orderServices.push(orderService)
    },

    /**
     * Adiciona um item na comanda
     */
    setCheckout(state, checkout) {
      state.checkout = checkout
    },

    bootstrapOrderService(state) {
      state.startNewOrderService = false, // status para iniciar criacao de uma nova ordem de serviço (comanda)
      state.checkout = [],
      state.customer = {},
      state.orderServiceSelected = {}
    },

    /**
     * Define se a comanda deve ser exibida por status
     */
    setTypePdv(state, status) {
      state.typePdv = status
    },

  },
  actions: {

    /**
     * Carrega as ordens de serviço (comandas)
     */
    loadOrderServices(context, typePdv) {
      return axios.get(`${route}`, {
        params: typePdv ? { type_pdv: typePdv } : {},
      })
    },

    getTableCount() {
      return axios.get(`${route}/table-count`)
    },

    updateTableCount(context, settings) {
      const payload = typeof settings === 'number' ? { table_count: settings } : settings

      return axios.put(`${route}/table-count`, payload)
    },

    getTableOrders() {
      return axios.get(`${route}/table-orders`)
    },

    getDeliveredTableOrders(context, date) {
      return axios.get(`${route}/table-orders/delivered`, { params: { date } })
    },

    sendTableOrderToKitchen(context, batchId) {
      return axios.patch(`${route}/table-orders/${encodeURIComponent(batchId)}/kitchen`)
    },

    confirmTableOrderDelivery(context, batchId) {
      return axios.patch(`${route}/table-orders/${encodeURIComponent(batchId)}/delivery`)
    },

    revertTableOrderDelivery(context, batchId) {
      return axios.patch(`${route}/table-orders/${encodeURIComponent(batchId)}/delivery/revert`)
    },

    createTableOrder(context, tableNumber) {
      return axios.post(`${route}`, {
        checkout: [],
        customer: null,
        status: 'iniciado',
        type_pdv: 'mesas',
        table_number: tableNumber,
      })
    },

    /**
     * Salva uma nova ordem de serviço (comanda)
     */
    saveOrderService(context) {
      // se for pdv de serviço, o status inicia como 'aguadando'

      let status = 'aguardando'
      if (context.getters.getTypePdv == 'atendimento') {
        // se for pdv de atendimento, o status inicia como 'iniciado'
        status = 'iniciado'
      } else if (context.getters.getTypePdv == 'servico') {
        status = 'aguardando'
      }

      const data = {
        checkout: context.getters.getCheckout,
        customer: context.getters.getCustomer,
        status,
        type_pdv: context.getters.getTypePdv,
      }

      return axios.post(`${route}`, data)
    },

    /**
     * Atualiza uma ordem de serviço (comanda)
     */
    updateOrderService(context, payload = {}) {
      const orderService = payload.orderService || context.getters.getOrderServiceSelected
      const data = payload.orderService
        ? {
          ...orderService,
          checkout: payload.checkout,
          customer: payload.customer,
        }
        : orderService

      updateOrderServiceQueue = updateOrderServiceQueue
        .catch(() => {})
        .then(() => axios.put(`${route}/${orderService.id}`, data))

      return updateOrderServiceQueue
    },

    /**
     * Atualiza o status de uma ordem de serviço (comanda)
     */
    updateStatus(context, { id, status }) {
      return axios.put(`${route}/update_status/${id}`, { status })
    },

    releaseEmptyTable(context, { id }) {
      return axios.put(`${route}/${id}/release-empty`)
    },

  },
}
